/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_SD_EXTERNAL_USER_COVERAGE_INFO } from './actionTypes';

import { fetchSdExternalUserCoverageInfoUtil } from './utils';

/**
 * Contains the action creator functions that update the SDUserCoverageInformation slice of the store.
 *
 * @namespace SDUserCoverageInformationActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_external_user_coverage_info
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof SDUserCoverageInformationActions
   */
  static fetchSdExternalUserCoverageInfo = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchSdExternalUserCoverageInfoUtil,
      FETCH_SD_EXTERNAL_USER_COVERAGE_INFO,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdExternalUserCoverageInfo.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof SDUserCoverageInformationActions
   */
  static resetFetchSdExternalUserCoverageInfo = (dispatch, data) => {
    const json = {
      type: FETCH_SD_EXTERNAL_USER_COVERAGE_INFO.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdExternalUserCoverageInfo.
   *
   * @param {function} dispatch
   * @function
   * @memberof SDUserCoverageInformationActions
   */
  static resetFetchSdExternalUserCoverageInfoError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SD_EXTERNAL_USER_COVERAGE_INFO.failureAction);
  };
}
